import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';

import { useDispatch, useSelector } from 'react-redux'
import { postAtivarUsuario, postReenviarCodigo } from '../serviceAPI/ativarconta';

export default function AtivacaoConta() {
    const dispatch = useDispatch();

    const [code, setCode] = React.useState('');

    const open = useSelector(state => state.ativarConta.open)
    const text = useSelector(state => state.ativarConta.text)
    const email = useSelector(state => state.ativarConta.email)
    const id = useSelector(state => state.ativarConta.idUser)

    async function ativar() {
        await postAtivarUsuario(id, code, dispatch)
    }

    async function reenviarCodigo() {
        await postReenviarCodigo(email, dispatch)
    }

    return (
        <div>
            <Dialog open={open} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Ativação da conta</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {text}
                    </DialogContentText>
                    <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="center">
                        <TextField
                            autoFocus
                            variant="outlined"
                            margin="dense"
                            id="name"
                            label="Codigo"
                            type="number"
                            value={code}
                            onChange={e => setCode(e.target.value)}
                        />
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={reenviarCodigo} color="primary">
                        Reenviar Código
                     </Button>
                    <Button onClick={ativar} color="primary">
                        Ativar
                     </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}